import { render } from "./TerminalsData.vue?vue&type=template&id=2b51447e"
import script from "./TerminalsData.vue?vue&type=script&lang=js"
export * from "./TerminalsData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__